import React from 'react'
import PropTypes from 'prop-types'

import Header from './header'

import Footer from './footer'
import './layout.css'

import es from 'react-intl/locale-data/es'
import pt from 'react-intl/locale-data/pt'
import en from 'react-intl/locale-data/en'
import { addLocaleData, IntlProvider } from 'react-intl'
import localEs from '../locale/es.json'
import localPt from '../locale/pt.json'
import localEn from '../locale/en.json'
import { Context } from './context'
import Provider from './provider'
import { FormattedMessage } from 'react-intl'
import { Children
        ,Declaration
       } from '../theme/globalStyle'
import License from './license';

addLocaleData([...es, ...pt, ...en])

const messages = {
	es: localEs,
	pt: localPt,
	en: localEn
}

const Layout = ({ children }) => (

	<Provider>
		<Context.Consumer>
			{({ lang }) => (
				<IntlProvider locale={lang} messages={messages[lang]}>
                <>
                    <Header/>
                    <Children>
                        <Declaration>
                            <FormattedMessage id="message-header" />
                            <br /><strong>&#9472; <FormattedMessage id="verse-message-header" /> &#9472;</strong>
                        </Declaration>
                        {children}
                        <Declaration>
                            <FormattedMessage id="message-footer" />
                            <br /><strong>&#9472; <FormattedMessage id="verse-message-footer" /> &#9472;</strong>
                        </Declaration>
                    </Children>
                    <Footer />
                    <License />
                </>
                </IntlProvider>
			)}
		</Context.Consumer>
	</Provider>
)

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout
